import React from 'react';
import styles from './AboutText.module.scss';

const AboutText = () => {
  return (
    <div className={styles.container}>
      <div className={styles.who_we_are}>
        <p>who we are</p>
        <h1>
          DreamLabs is a multidisciplinary studio made up of designers, builders, writers, and
          entrepreneurs who care deeply about how things are made. And why. We exist at the
          intersection of technology and art where we help brands find their best selves. We are an
          independent team of designers, builders, writers, and entrepreneurs obsessed with growth.
          By bridging the precise world of technology with the expressive realm of art, we deliver
          integrated solutions in branding, content strategy, and software development.
        </h1>
      </div>
      <h1></h1>
      <div className={styles.what_we_do}>
        <p>what we do</p>
        <h1>
          We help businesses design, build, and grow products and brands through a blend of creative
          and technical services.
          <ul>
            <li>UX/UI & Visual Design</li>
            <li>Creative & Motion Direction</li>
            <li>Brand, Product & Content Strategy</li>
            <li>Software Development & Maintenance</li>
            <li>Growth Marketing & Optimisation</li>
          </ul>
        </h1>
      </div>
    </div>
  );
};

export default AboutText;
